<div [@enterAnimation] [@leaveAnimation]>
    <div class="float-l relative">
        <div class="link-all-tenders" title="חזרה לכל המכרזים"><button type="button" mat-mini-fab color="link" (click)="onCancel()" aria-label="חזרה לכל המכרזים"><mat-icon>arrow_back_ios</mat-icon></button></div>
    </div>
    <div>
        <h2 class="middle-blue top-title first-focus" tabindex="0" style="width:fit-content">מילוי שאלות הבהרה</h2>
    </div>
    <div class="tender-details">
        <div><label class="fs-15">שם מכרז: </label><b class="fs-20">{{tender.Title}}</b></div>
        <div><label class="fs-15">מספר מכרז: </label><b class="fs-20">{{tender.MolsaTenderNumber}}</b></div>
    </div>
    <div class="star-msg">שדות המסומנים ב-* הם שדות חובה</div>
    <div class="fs-15">
        תשובות לשאלות ההבהרה ועדכונים למכרז ימסרו רק למי שנרשם לקבלת עדכונים באמצעות אתר המשרד.
    </div>
    <form [formGroup]="qForm" #ngForm="ngForm" [class]="isSubmitted?'is-submitted':'is-not-submitted'">
        <div class="flex">
            <label for="HasRegistration" class="flex-1 label-15 label-required">
                <span aria-hidden="true" class="mat-form-field-required-marker">* </span>
                <b>האם נרשמת לקבלת עדכונים למכרז?</b>
            </label>
            <mat-form-field class="flex-1 mat-form-field-radio-group radio-row mat-form-field-col">
                <input type="text" placeholder="" matInput formControlName="HasRegistration" style="display:none" required>
                <mat-radio-group formControlName="HasRegistration" name="HasRegistration">
                    <mat-radio-button value="true" aria-label="האם נרשמת לקבלת עדכונים למכרז? כן">&nbsp; כן</mat-radio-button>
                    <mat-radio-button value="false" aria-label="לא">&nbsp; לא</mat-radio-button>
                </mat-radio-group>
            </mat-form-field>
        </div>
        <div *ngIf="qForm.value.HasRegistration=='true'">
            <fieldset class="box">
                <legend><h3>פרטי איש הקשר</h3></legend>
                <div class="split-box-title"></div>
                <div class="row-items">
                    <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                        <mat-label>שם המציע הפוטנציאלי</mat-label>
                        <input type="text" placeholder="שם המציע הפוטנציאלי" matInput formControlName="ContactName" maxlength="50" required />
                        <!--<div class="mat-form-field-subscript-wrapper"><div class="mat-error">{{getError('ContactName')}}</div></div>-->
                        <mat-error>{{getError('ContactName')}}</mat-error>
                    </mat-form-field>
                    <div></div>
                </div>
                <div>
                    <mat-form-field class="mat-field-100 mat-form-field-label-15">
                        <mat-label>פרטי איש קשר</mat-label>
                        <textarea matInput formControlName="ContactDetails" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5" required ></textarea> 
                        <mat-error>{{getError('ContactDetails')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="row-items">
                    <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                        <mat-label>טלפון 1</mat-label>
                        <input type="text" placeholder="טלפון 1" matInput formControlName="ContactPhone1" maxlength="50" required  /> 
                        <mat-error>{{getError('ContactPhone1')}}</mat-error>
                    </mat-form-field> 
                    <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                        <mat-label>טלפון 2</mat-label>
                        <input type="text" placeholder="טלפון 2" matInput formControlName="ContactPhone2" maxlength="50"  /> 
                        <mat-error>{{getError('ContactPhone2')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="row-items">                
                    <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                        <mat-label>דואר אלקטרוני</mat-label>
                        <input type="email" placeholder="דואר אלקטרוני" matInput formControlName="ContactEmail" maxlength="50" required  /> 
                        <mat-error>{{getError('ContactEmail')}}</mat-error>
                    </mat-form-field> 
                    <mat-form-field class="mat-form-field-row mat-form-field-label-15">
                        <mat-label>פקס</mat-label>
                        <input type="text" placeholder="פקס" matInput formControlName="ContactFax" maxlength="50"  /> 
                        <mat-error>{{getError('ContactFax')}}</mat-error>
                    </mat-form-field>      
                </div>
            </fieldset>
            <fieldset class="box">
                <legend><h3>שאלות הבהרה</h3></legend>
                <div class="split-box-title"></div>
                <div formArrayName="Questions" *ngFor="let x of qsList;let i=index" class="div-q">
                    <div class="space-between">
                        <b><h4>שאלה {{getIndex(i)}}</h4> </b>
                        <span class="pointer middle-blue margin-l-16" (click)="deleteQuestion(i)" *ngIf="qsList.length>1" tabindex="0" (keyup.enter)="deleteQuestion(i)" [attr.aria-label]="'מחיקת שאלה '+getIndex(i)" role="button"><mat-icon>remove_circle_outline</mat-icon></span>
                    </div>
                    <div [formGroupName]="i">
                        <div>
                            <mat-form-field class="mat-field-100 mat-form-field-label-15">
                                <mat-label>הסעיף/הסעיפים במכרז<span class="mobile-hide"> לגביהם נשאלת שאלה {{getIndex(i)}}</span></mat-label>
                                <textarea matInput formControlName="RelatedSection" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5" required ></textarea>
                                <mat-error>{{getQError('RelatedSection',i)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div>
                            <mat-form-field class="mat-field-100 mat-form-field-label-15">
                                <mat-label>פירוט השאלה</mat-label>
                                <textarea matInput formControlName="QuestionDesc" cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10" required ></textarea>
                                <mat-error>{{getQError('QuestionDesc',i)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <span class="pointer middle-blue add-q" (click)="addQuestion()" tabindex="0" (keyup.enter)="addQuestion()" role="button">
                    <mat-icon>add_circle_outline</mat-icon>
                    <span>&nbsp; הוספת שאלה</span>
                </span>
            </fieldset>
            <div class="div-save-btn">
                <button mat-raised-button color="primary" type="submit" (click)="onSubmit()" [disabled]="lockBtn">שליחה</button>
                <button mat-raised-button color="primary" type="button" (click)="onCancel()">ביטול</button>
            </div>
        </div>
    </form>
</div>
